const EVIDENCE_OF_FORMATION_DOCUMENT_TYPES = {
  GOVERNMENT_ISSUED_OWNERSHIP_CERTIFICATE: {
    value: "government_issued_ownership_certificate",
    readableName: "Government Issued Ownership Certificate",
  },
  REGULATORY_FILINGS_SHOWING_GOVERNMENT_OWNERSHIP: {
    value: "regulatory_filings_showing_government_ownership",
    readableName: "Regulatory Filings Showing Government Ownership",
  },
  GOVERNMENT_OWNED_ENTITY_REGISTRY: {
    value: "government_owned_entity_registry",
    readableName: "Government Owned Entity Registry",
  },
};

export const evidenceOfFormationDocumentTypesArray = Object.values(
  EVIDENCE_OF_FORMATION_DOCUMENT_TYPES,
);
